module.exports = __webpack_public_path__ + "f342c3045423bce814e01710bee99a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2002_teaser_image.jpg
// module id = 554
// module chunks = 0